/**
 * Main entry point for the React application
 * Sets up React DOM rendering
 */

import React from 'react'
import ReactDOM from 'react-dom/client'
import './styles/index.css'
import App from './App'

// Create root element and render app
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
